// October 2026 audit: concise metadata for confirmed overlong fields.
export const SEO_AUDIT_METADATA: Record<string, { title: string; description: string }> = {
  "/assessment": {
    "title": "ESA Letter Assessment | Start Online | PawTenant",
    "description": "Begin your ESA letter application in minutes. Answer a short questionnaire, connect with a licensed LMHP, and receive your ESA letter fast."
  },
  "/how-to-get-esa-letter": {
    "title": "How to Get an ESA Letter: Step-by-Step | PawTenant",
    "description": "How to get an ESA letter step by step: a licensed provider evaluation, a verifiable housing-focused letter, and a refund if you don't qualify."
  },
  "/everything-you-need-to-know-about-obtaining-an-esa-letter-online": {
    "title": "Obtaining an ESA Letter Online: Full Guide | PawTenant",
    "description": "Obtaining an ESA letter online: who qualifies, how licensed evaluations work, what makes a letter housing-ready, and how to spot fake sites."
  },
  "/esa-letter-housing": {
    "title": "ESA Letter for Housing | Licensed Review | PawTenant",
    "description": "Get an ESA letter for housing after a confidential assessment by a professional licensed in your state. Issued only if appropriate; refund if not."
  },
  "/service-animal-vs-esa": {
    "title": "Service Animal vs ESA vs Therapy Dog | PawTenant",
    "description": "Service animal vs ESA vs therapy dog: compare legal rights, training, housing protections, and airline access side by side for 2026."
  },
  "/all-about-service-dogs": {
    "title": "Service Dogs: PSD Letter vs ESA Letter | PawTenant",
    "description": "Everything about service dogs: how a psychiatric service dog letter differs from an ESA letter, who may qualify, and how an evaluation works."
  },
  "/how-to-get-psd-letter": {
    "title": "How to Get a PSD Letter | PawTenant",
    "description": "How to get a PSD letter (psychiatric service dog) through a licensed provider evaluation. Learn how a PSD differs from an ESA and whether you may qualify."
  },
  "/psd-assessment": {
    "title": "PSD Letter Assessment | Start Online | PawTenant",
    "description": "Get a legitimate Psychiatric Service Dog (PSD) letter from a licensed mental health professional. ADA compliant, HIPAA secure, delivered within 24 hours. Start your free PSD assessment."
  },
  "/join-our-network": {
    "title": "Join PawTenant's Licensed Provider Network | PawTenant",
    "description": "Licensed clinicians: join PawTenant's ESA provider network reviewing ESA and PSD requests, with flexible case acceptance and full admin support."
  },
  "/college-pet-policy": {
    "title": "ESA Letter for College Dorms: 2026 Guide | PawTenant",
    "description": "An ESA letter for college can help you keep an emotional support animal in university housing. How dorm requests work and how to get one."
  },
  "/airline-pet-policy": {
    "title": "Airline ESA Policy & Pet Rules 2026 | PawTenant",
    "description": "Each airline ESA policy for 2026: Delta, United, American, Southwest and more, plus when a psychiatric service dog letter applies to air travel."
  },
  "/renew-esa-letter": {
    "title": "Renew Your ESA Letter | PawTenant",
    "description": "ESA letters expire after 12 months. Renew your emotional support animal letter with a licensed therapist in 2026. Fast delivery and a refund if you don't qualify. From $115."
  },
  "/faqs": {
    "title": "ESA FAQs: Your ESA Letter Questions Answered | PawTenant",
    "description": "ESA FAQs answered: letters, housing rights, college dorms, air travel, renewals, and verification, from PawTenant's licensed provider network."
  },
  "/about-us": {
    "title": "About PawTenant | Our Network of Licensed Professionals",
    "description": "About PawTenant: a network of licensed mental health providers putting clinical integrity and fair housing compliance first in every evaluation."
  },
  "/contact-us": {
    "title": "Contact PawTenant | ESA Letter Support — Email & Phone Help",
    "description": "Contact PawTenant for ESA letter support: call (409) 965-5885, email hello@pawtenant.com, or use our form. Mon–Fri, 7am–6pm CT."
  },
  "/resource-center": {
    "title": "ESA & PSD Resource Center | PawTenant",
    "description": "The PawTenant ESA & PSD resource center: guides on state laws, housing rights, travel policies, and landlord verification in one place."
  },
  "/refund-policy": {
    "title": "Refund Policy | PawTenant",
    "description": "PawTenant's refund policy: a full refund if a licensed provider finds you don't qualify, plus an evidence-based review of housing-denial claims."
  },
  "/our-providers": {
    "title": "Our Licensed ESA Providers | PawTenant",
    "description": "Meet our licensed ESA providers. Each conducts individual telehealth ESA and PSD evaluations only in the states where they hold a license."
  },
  "/doctors/eve-rosno": {
    "title": "Eve Rosno, Licensed Psychologist | PawTenant",
    "description": "Eve Rosno is a licensed psychologist providing individual telehealth ESA evaluations through PawTenant. NPI-verified."
  },
  "/esa-laws": {
    "title": "ESA Laws & ESA Letter Requirements Explained | PawTenant",
    "description": "ESA laws explained: how the Fair Housing Act protects emotional support animal owners, what a valid letter requires, and what it can't do."
  },
  "/are-online-esa-letters-legit": {
    "title": "Are Online ESA Letters Legit? | PawTenant",
    "description": "How to tell if an online ESA letter is real: a licensed provider evaluation, a named provider, and a verifiable letter — and how to avoid fake registrations."
  },
  "/california-esa-letter-30-day-rule": {
    "title": "California ESA Letter & the 30-Day Rule (AB 468) | PawTenant",
    "description": "Getting a California ESA letter: AB 468 requires a 30-day provider relationship and a clinical evaluation first. Here's how to comply."
  },
  "/iowa-esa-letter-housing-rules": {
    "title": "Iowa ESA Letter & Housing Rules (§ 216.8B) | PawTenant",
    "description": "Iowa ESA letter rules: Code § 216.8B and SF 2268 protect assistance animals in housing. What Iowa landlords can ask and what documents need."
  },
  "/landlord-denied-esa-letter": {
    "title": "Landlord Denied ESA Letter? Next Steps | PawTenant",
    "description": "Landlord denied your ESA? Calm next steps, your options, and how a licensed provider letter with landlord-ready support can help. Refund if you don't qualify."
  },
  "/best-online-esa-letter-service": {
    "title": "Best Online ESA Letter Service: How to Choose",
    "description": "How to choose a real online ESA letter service: licensed provider evaluation, transparent pricing, verifiable letters, and housing-focused support."
  },
  "/how-to-get-esa-letter-online": {
    "title": "How to Get an ESA Letter Online | PawTenant",
    "description": "Get an ESA letter online via a licensed provider evaluation: a fast telehealth assessment, a verifiable letter for housing, and a refund if you don't qualify."
  },
  "/esa-psd-registry-vs-letter": {
    "title": "ESA Registry vs Letter: What Landlords Need | PawTenant",
    "description": "ESA registry vs letter: why registries, certificates, and ID cards fall short, and what provider-reviewed documentation landlords accept."
  },
  "/is-pawtenant-legit": {
    "title": "Is PawTenant Legit? How the ESA Letter Service Works",
    "description": "Is PawTenant legit? We connect you with licensed providers for ESA letters, with transparent pricing, verifiable letters, and a refund policy."
  },
  "/are-esa-letters-still-valid-after-hud-change": {
    "title": "Are ESA Letters Still Valid After the 2026 HUD Change?",
    "description": "Are ESA letters still valid after HUD's 2026 change? What changed, what didn't, ESA vs trained PSD, and how a licensed evaluation helps."
  },
  "/travel-anxiety-esa-letter": {
    "title": "ESA Letter for Travel Anxiety | PawTenant",
    "description": "How an ESA letter for travel anxiety and temporary housing works, how an emotional support animal may help, and what the letter can't do."
  },
  "/pet-rent-savings-calculator": {
    "title": "Pet Rent Savings Calculator | Estimate ESA Housing Savings",
    "description": "Use our pet rent savings calculator to see how pet rent and fees add up over 1, 2, and 5 years if an ESA accommodation is approved."
  },
  "/esa-accommodation-request-letter": {
    "title": "ESA Accommodation Request Letter Template | PawTenant",
    "description": "Write a clear ESA accommodation request letter for your landlord: what to include, a simple template, and how it pairs with your ESA letter."
  },
  "/landlord-esa-documentation-checklist": {
    "title": "Landlord ESA Documentation Checklist | What to Review",
    "description": "A landlord ESA documentation checklist: what you can request, what you can't ask, and how to verify a letter without seeing medical details."
  },
  "/california-esa-letter-for-apartments": {
    "title": "California ESA Letter for Apartments | Renter Housing Guide",
    "description": "A California ESA letter for apartments: how AB 468's 30-day rule, a licensed evaluation, and a verifiable letter support your housing request."
  },
  "/texas-esa-letter-for-apartments": {
    "title": "Texas ESA Letter for Apartments | Renter Housing Guide",
    "description": "A Texas ESA letter for apartments: how a licensed evaluation and a verifiable letter support an accommodation request with property managers."
  },
  "/florida-esa-letter-for-apartments": {
    "title": "Florida ESA Letter for Apartments | Renter Housing Guide",
    "description": "A Florida ESA letter for apartments and condos: Statute 760.27, a licensed provider evaluation, and a verifiable letter for your request."
  },
  "/new-york-esa-letter-for-apartments": {
    "title": "New York ESA Letter for Apartments | Renter Housing Guide",
    "description": "A New York ESA letter for apartments, co-ops, and condos: how a licensed evaluation and verifiable letter support your accommodation request."
  },
  "/esa-letter/louisiana": {
    "title": "ESA Letter in Louisiana | Licensed Providers | PawTenant",
    "description": "Get a legitimate ESA letter in Louisiana. PawTenant works with licensed Louisiana mental health professionals to issue FHA-compliant documentation."
  },
  "/esa-letter/new-hampshire": {
    "title": "ESA Letter New Hampshire | Fast & Legitimate | PawTenant",
    "description": "Get an ESA letter in New Hampshire after an evaluation with a professional licensed in New Hampshire. Housing-focused, verifiable, refund if you don't qualify."
  },
  "/esa-letter/virginia": {
    "title": "ESA Letter Virginia | Licensed Therapists | PawTenant",
    "description": "Get an ESA letter in Virginia after an evaluation with a professional licensed in Virginia. Housing-focused, verifiable, refund if you don't qualify."
  },
  "/psd-letter/california": {
    "title": "PSD Letter in California | Psychiatric Service Dog",
    "description": "Get a PSD letter in California through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/texas": {
    "title": "PSD Letter in Texas: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Texas through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/florida": {
    "title": "PSD Letter in Florida: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Florida through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/new-york": {
    "title": "PSD Letter in New York: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in New York through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/ohio": {
    "title": "PSD Letter in Ohio: Psychiatric Service Dog | PawTenant",
    "description": "Psychiatric Service Dog (PSD) documentation in Ohio via a licensed provider evaluation. PSD vs ESA, Ohio Civil Rights Act context, refund if you don't qualify."
  },
  "/psd-letter/washington": {
    "title": "PSD Letter in Washington | Psychiatric Service Dog",
    "description": "Get a PSD letter in Washington through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/illinois": {
    "title": "PSD Letter in Illinois: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Illinois through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/georgia": {
    "title": "PSD Letter in Georgia: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Georgia through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/north-carolina": {
    "title": "PSD Letter in North Carolina | Psychiatric Service Dog",
    "description": "Get a PSD letter in North Carolina through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/arizona": {
    "title": "PSD Letter in Arizona: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Arizona through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/michigan": {
    "title": "PSD Letter in Michigan: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Michigan through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/new-jersey": {
    "title": "PSD Letter in New Jersey | Psychiatric Service Dog",
    "description": "Get a PSD letter in New Jersey through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/virginia": {
    "title": "PSD Letter in Virginia: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Virginia through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/colorado": {
    "title": "PSD Letter in Colorado: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Colorado through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/pennsylvania": {
    "title": "PSD Letter in Pennsylvania | Psychiatric Service Dog",
    "description": "Get a PSD letter in Pennsylvania through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/minnesota": {
    "title": "PSD Letter in Minnesota: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Minnesota through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/psd-letter/oregon": {
    "title": "PSD Letter in Oregon: Psychiatric Service Dog | PawTenant",
    "description": "Get a PSD letter in Oregon through a licensed provider evaluation. How a psychiatric service dog differs from an ESA. Refund if you don't qualify."
  },
  "/college-pet-policy/unc-chapel-hill": {
    "title": "ESA Letter for UNC Chapel Hill Students | PawTenant",
    "description": "Get an ESA letter for UNC Chapel Hill housing: how dorm accommodation requests work and how a licensed professional evaluates you."
  },
  "/college-pet-policy/carnegie-mellon": {
    "title": "ESA Letter for Carnegie Mellon University | PawTenant",
    "description": "Keep your emotional support animal in Carnegie Mellon housing. Fast, legitimate ESA letters from licensed professionals. Apply online with PawTenant today."
  },
  "/college-pet-policy/dartmouth": {
    "title": "ESA Letter for Dartmouth College Students | PawTenant",
    "description": "Get an ESA letter for Dartmouth College housing: how dorm accommodation requests work and how a licensed professional evaluates you."
  },
  "/college-pet-policy/brown": {
    "title": "ESA Letter for Brown University Students | PawTenant",
    "description": "Get an ESA letter for Brown University housing: how dorm accommodation requests work and how a licensed professional evaluates you."
  },
  "/college-pet-policy/cornell": {
    "title": "ESA Letter for Cornell University Students | PawTenant",
    "description": "Get an ESA letter for Cornell University housing: how dorm accommodation requests work and how a licensed professional evaluates you."
  },
  "/college-pet-policy/johns-hopkins": {
    "title": "ESA Letter for Johns Hopkins University Students | PawTenant",
    "description": "Get an ESA letter for Johns Hopkins University housing: how dorm accommodation requests work and how a licensed professional evaluates you."
  },
  "/college-pet-policy/ucla": {
    "title": "ESA Letter for UCLA Students | PawTenant",
    "description": "Get an ESA letter for UCLA housing. Learn how dorm accommodation requests work and how a licensed professional evaluates eligibility."
  },
  "/blog/2026-hud-esa-guidelines": {
    "title": "2026 HUD ESA Guidelines: Is Your ESA Letter Still Valid?",
    "description": "The 2026 HUD ESA guidelines may change how untrained ESAs are handled in housing complaints. What changed, what rights remain, and PSD differences."
  },
  "/states/california-esa-psd-guide": {
    "title": "California ESA & PSD Guide: AB 468 | PawTenant",
    "description": "California ESA & PSD law: AB 468's 30-day rule, ESA vs PSD differences, what landlords and HOAs can and can't do, and what a letter needs."
  },
  "/states/los-angeles-esa-landlord-guide": {
    "title": "Los Angeles Landlord ESA Rules: RSO & AB 468 | PawTenant",
    "description": "Los Angeles landlord ESA rules: how the RSO and Just Cause Ordinances layer on AB 468, from no-pet policies to pet fees and eviction."
  },
  "/states/san-francisco-hoa-psd-guide": {
    "title": "San Francisco HOA Rules & PSD Rights | PawTenant",
    "description": "How Davis-Stirling, FEHA, and the ADA limit San Francisco HOA pet rules (breed bans, weight caps, fees) for residents with a psychiatric service dog."
  },
  "/states/san-diego-telehealth-guide": {
    "title": "San Diego Telehealth ESA Guidelines Under AB 468 | PawTenant",
    "description": "San Diego telehealth ESA evaluations under AB 468: California licensure, the 30-day rule, required disclosures, and how to check a provider."
  },
  "/blog/how-to-train-psychiatric-service-dog-tasks": {
    "title": "Psychiatric Service Dog Tasks: How to Train | PawTenant",
    "description": "Psychiatric service dog tasks under the ADA: which tasks qualify, how self-training works legally, public-access standards, and documentation."
  },
  "/states/texas-esa-psd-guide": {
    "title": "Texas ESA & PSD Housing Laws 2026 | PawTenant",
    "description": "Texas ESA & PSD housing law: no state waiting period, the 2026 HUD enforcement shift, fee exemptions, and misrepresentation penalties."
  },
  "/blog/texas-service-animal-laws-penalties": {
    "title": "Texas Service Animal Laws & Penalties for Misrepresentation",
    "description": "Texas service animal laws vs ESA rules: the task standard, the HB 4164 misrepresentation penalty, and what businesses and landlords may ask."
  },
  "/blog/how-to-get-an-esa-letter-online": {
    "title": "How to Get an ESA Letter Online in 2026: Step-by-Step Guide",
    "description": "How to get a legitimate ESA letter online in 2026: who qualifies, the licensed evaluation, cost, timing, housing rights, and avoiding scam registries."
  },
  "/blog/what-is-an-esa-letter": {
    "title": "What Is an ESA Letter? 2026 Legal Requirements & Guide",
    "description": "What is an ESA letter? What a valid one contains, who can write it, and what protections it still gives after HUD's 2026 enforcement change."
  },
  "/blog/esa-letter-requirements": {
    "title": "ESA Letter Requirements: What Makes It Valid in 2026",
    "description": "The 10 elements a valid ESA letter must contain to be accepted by landlords, what makes one invalid, the state rules, and what HUD's 2025–2026 shifts changed."
  },
  "/blog/can-puppies-qualify-as-esas": {
    "title": "Can You Have a Puppy as an ESA? | PawTenant",
    "description": "Can you have a puppy as an ESA? There's no minimum age, but puppies bring real care and tenancy risks. What the rules say and what clinicians weigh."
  },
  "/blog/how-to-request-esa-accommodation-from-landlord": {
    "title": "Requesting an ESA Accommodation From Your Landlord",
    "description": "How to submit an emotional support animal accommodation request: what to send, how to word it, what a landlord may ask, and what to do if you are refused."
  },
  "/blog/when-should-you-renew-your-esa-letter": {
    "title": "When to Renew Your ESA Letter | PawTenant",
    "description": "How long ESA documentation stays current, the five events that should trigger a renewal, and why twelve months is landlord practice, not federal law."
  },
  "/blog/pet-rent-explained": {
    "title": "Pet Rent Explained: What Renters Should Know | PawTenant",
    "description": "What pet rent is, how it differs from a pet deposit and pet fee, how much it can add up to over time, and how housing-focused ESA documentation fits in."
  },
  "/blog/apartment-pet-rent-and-esa-letters": {
    "title": "Apartment Pet Rent and ESA Letters: What Renters Should Know",
    "description": "How apartment pet rent works, when an approved emotional support animal can't be charged pet fees, and how to make an accommodation request."
  },
  "/blog/pet-deposit-vs-pet-rent": {
    "title": "Pet Deposit vs. Pet Rent: What Is the Difference?",
    "description": "Pet deposit vs pet rent vs pet fee: what each is, which are refundable, how they add up, and how approved ESA documentation changes the picture."
  },
  "/blog/california-pet-rent-and-esa-letters": {
    "title": "California Pet Rent & ESA Letters | PawTenant",
    "description": "How California pet rent works, the state's AB 468 ESA rule, and when an approved emotional support animal can't be charged pet fees."
  },
  "/blog/new-york-pet-rent-and-esa-letters": {
    "title": "New York Pet Rent and ESA Letters: What Renters Should Know",
    "description": "How New York pet rent works, co-op and condo board review, and when an approved emotional support animal can't be charged pet fees."
  },
  "/blog/florida-pet-rent-and-esa-letters": {
    "title": "Florida Pet Rent and ESA Letters: What Renters Should Know",
    "description": "How Florida pet rent works in apartments and condos, Statute 760.27's ESA rule, and when an approved ESA can't be charged pet fees."
  },
  "/blog/washington-pet-rent-and-esa-letters": {
    "title": "Washington Pet Rent & ESA Letters | PawTenant",
    "description": "How Washington pet rent works in Seattle-area rentals, the state's assistance-animal protections, and when an approved ESA can't be charged fees."
  },
  "/blog/emotional-support-animal-travel-anxiety": {
    "title": "ESA for Travel Anxiety: Can It Help? | PawTenant",
    "description": "Can an ESA for travel anxiety help on flights and road trips? How it may ease stress, plus the legal limits: ESA rights center on housing."
  },
  "/blog/temporary-housing-emotional-support-animal": {
    "title": "ESA in Temporary Housing & Extended Stays | PawTenant",
    "description": "Can you keep an ESA in temporary housing, extended stays, or short-term rentals? What the Fair Housing Act covers and how policies differ."
  },
  "/blog/crowds-travel-stress-emotional-support-animal": {
    "title": "Crowds, Travel Stress & ESAs | PawTenant",
    "description": "Crowds and travel stress can overwhelm anyone. How an emotional support animal may help you stay grounded, and why an ESA isn't venue access."
  },
  "/blog/psychiatric-service-dog-letter-explained": {
    "title": "Psychiatric Service Dog Letters Explained | PawTenant",
    "description": "Psychiatric service dog letters in plain English: what they are, who qualifies, how they differ from an ESA letter, and when they actually help."
  },
  "/blog/psd-letter-vs-service-dog-certificate": {
    "title": "PSD Letter vs Service Dog Certificate | PawTenant",
    "description": "PSD letter vs service dog certificate: why online certificates carry no legal weight, and what a licensed provider's documentation actually does."
  },
  "/blog/psd-letter-for-anxiety": {
    "title": "Can You Get a PSD Letter for Anxiety?",
    "description": "Can you get a PSD letter for anxiety? Yes, if it rises to a disability and your dog performs trained tasks. Here's how the evaluation works."
  },
  "/blog/psychiatric-service-dog-housing-rights": {
    "title": "Psychiatric Service Dog Housing Rights | PawTenant",
    "description": "Psychiatric service dog housing rights for renters: Fair Housing Act protections, what landlords can ask, no pet fees, and how to request."
  },
  "/blog/can-anxiety-qualify-you-for-a-psd": {
    "title": "Can Anxiety Qualify You for a Psychiatric Service Dog?",
    "description": "A psychiatric service dog for anxiety is possible if it rises to a disability and the dog is task-trained. PSD vs ESA, plus ADA and housing rules."
  },
  "/blog/can-depression-qualify-psychiatric-service-dog": {
    "title": "Can Depression Qualify You for a Psychiatric Service Dog?",
    "description": "A psychiatric service dog for depression is possible when it's disabling and the dog is task-trained. Task examples, ADA rules, and documentation."
  },
  "/blog/can-depression-qualify-you-for-an-esa": {
    "title": "Can Depression Qualify You for an ESA?",
    "description": "An ESA for depression may be appropriate when a licensed professional confirms it limits a major life activity. Symptoms, letter rules, and HUD 2026."
  },
  "/blog/esa-complete-guide-2026-whats-updated": {
    "title": "ESA Complete Guide 2026: What’s New & Updated | PawTenant",
    "description": "Our ESA guide 2026 edition: HUD policy updates, state law changes, new landlord rules, ESA letter requirements, and what changed since 2025."
  },
  "/blog/psd-complete-guide-2026-whats-updated": {
    "title": "PSD Guide 2026: Psychiatric Service Dog Laws | PawTenant",
    "description": "Our PSD guide 2026 edition: psychiatric service dog ADA rights, airline policies, training requirements, PSD letters, and PSD vs ESA."
  },
  "/blog/esa-california-2026-update": {
    "title": "California ESA 2026 Update: AB 468 | PawTenant",
    "description": "California ESA 2026 update: what changed under AB 468, how landlords are verifying letters, and how California renters can stay protected."
  },
  "/blog/esa-texas-2026-update": {
    "title": "Texas ESA 2026 Update: Housing Rights | PawTenant",
    "description": "Texas ESA housing rights in 2026: what’s changed, trending landlord practices, and how Texas renters can protect themselves with a valid ESA letter."
  },
  "/blog/esa-florida-2026-update": {
    "title": "Florida ESA 2026 Update: Anti-Fraud Rules | PawTenant",
    "description": "Florida ESA 2026 update: anti-fraud enforcement, how landlords are verifying letters, and how Florida renters can stay protected."
  },
  "/blog/esa-new-york-2026-update": {
    "title": "New York ESA 2026 Update: NYC Tenant Rights | PawTenant",
    "description": "New York ESA 2026 update: co-op board rulings, NYC Human Rights Law enforcement, and how renters can protect their ESA housing rights."
  },
  "/blog/esa-letter-cost-california-2026": {
    "title": "ESA Letter Cost in California 2026 | PawTenant",
    "description": "The ESA letter cost in California for 2026: fair pricing under AB 468, red flags to avoid, and how to get a legitimate California ESA letter."
  },
  "/blog/texas-esa-landlord-rights-2026": {
    "title": "Texas ESA Landlord Rights 2026 | PawTenant",
    "description": "Texas ESA landlord rights in 2026: what Texas landlords can and can't do, how to get a legitimate ESA letter, and what to do if you're denied."
  },
  "/blog/florida-esa-letter-renters-2026": {
    "title": "ESA Letter for Florida Renters 2026 | PawTenant",
    "description": "An ESA letter for Florida renters: your rights under Florida law and the FHA, how to get a compliant letter, and what to do if you're denied."
  },
  "/blog/new-york-esa-letter-apartment-2026": {
    "title": "ESA Letter for a New York Apartment | PawTenant",
    "description": "Getting an ESA letter for a New York apartment: NY's layered housing protections, how to submit your request, and what to do if a landlord objects."
  },
  "/blog/what-landlords-cannot-legally-do-esa": {
    "title": "What Landlords Can't Legally Do About ESAs | PawTenant",
    "description": "What landlords can't legally do to ESA owners, from charging pet fees to demanding a diagnosis. See exactly what's off-limits under federal law."
  },
  "/blog/hoa-esa-rights-2026": {
    "title": "HOA ESA Rights 2026: Homeowner Guide | PawTenant",
    "description": "HOA ESA rights in 2026: what associations must do under the Fair Housing Act, recent enforcement cases, and how to respond to a denial."
  },
  "/blog/how-esas-help-ptsd-2026": {
    "title": "How ESAs Help PTSD: Science & Evidence 2026 | PawTenant",
    "description": "How an ESA for PTSD can help: what the research says, how emotional support animals provide support, and how ESA eligibility is assessed."
  },
  "/blog/esa-for-anxiety-depression-mental-health-guide-2026": {
    "title": "ESA for Anxiety & Depression: 2026 Guide | PawTenant",
    "description": "Can an ESA for anxiety & depression help? The evidence, how ESAs provide therapeutic benefit, and how a licensed professional assesses eligibility."
  },
  "/blog/esa-letters-for-veterans-2026": {
    "title": "ESA Letters for Veterans 2026 | PawTenant",
    "description": "ESA letters for veterans: getting one through VA or private providers, how VA therapy animals differ from ESAs, and veterans' housing rights."
  },
  "/blog/esa-ohio-2026-guide": {
    "title": "Ohio ESA Housing Rights 2026 | PawTenant",
    "description": "Ohio ESA rights in 2026: Civil Rights Act protections, what Columbus, Cleveland and Cincinnati landlords can ask, and getting an Ohio ESA letter."
  },
  "/blog/esa-washington-state-2026-guide": {
    "title": "Washington ESA Housing Rights 2026 | PawTenant",
    "description": "Washington ESA rights in 2026: WLAD protections, Seattle, Bellevue and Tacoma landlord trends, and how to get a Washington-compliant ESA letter."
  },
  "/blog/esa-illinois-chicago-2026-guide": {
    "title": "Illinois ESA Rights 2026: Chicago Guide | PawTenant",
    "description": "Illinois ESA rights in 2026: Chicago Human Rights Ordinance and ILHRA protections, and how to get a compliant ESA letter for a Chicago apartment."
  },
  "/blog/how-to-get-esa-letter-from-doctor": {
    "title": "Getting an ESA Letter From a Doctor or Therapist",
    "description": "Getting an ESA letter from a doctor, a therapist, or an online provider: how each legitimate route works in 2026 and what to expect."
  },
  "/blog/what-a-legit-esa-letter-looks-like-checklist-examples": {
    "title": "What a Legit ESA Letter Looks Like | PawTenant",
    "description": "What does a legitimate ESA letter look like? Use our checklist and examples to verify your ESA letter meets all legal requirements."
  },
  "/blog/how-to-renew-esa-letter-2026": {
    "title": "How to Renew Your ESA Letter in 2026 | PawTenant",
    "description": "How to renew your ESA letter in 2026: when to start, the steps involved, and what landlords typically expect to see on a renewed letter."
  },
  "/blog/esa-housing-denial-rights-2026": {
    "title": "ESA Housing Denial: Your Rights in 2026 | PawTenant",
    "description": "Facing an ESA housing denial? Your rights under the Fair Housing Act in 2026 and the exact steps to take to challenge your landlord's decision."
  },
  "/blog/esa-letter-college-dorms-2026-complete-guide": {
    "title": "ESA Letter for College Dorms 2026 | PawTenant",
    "description": "How to get an ESA letter for college dorms in 2026: federal rights, the university approval process, documentation, and timing tips."
  },
  "/blog/esa-vs-service-animal-key-differences-2026": {
    "title": "ESA vs Service Animal: Legal Differences | PawTenant",
    "description": "ESA vs service animal in 2026: the legal differences, which protections each has, and how to tell which designation fits your needs."
  },
  "/blog/can-landlord-evict-me-for-having-esa-2026": {
    "title": "Can a Landlord Evict You for Having an ESA? | PawTenant",
    "description": "Can a landlord evict you for having an ESA? When eviction is and isn't legal, your Fair Housing Act rights, and what to do if threatened."
  },
  "/blog/mental-health-conditions-qualify-esa-2026": {
    "title": "10 Conditions That Qualify for an ESA | PawTenant",
    "description": "Ten mental health conditions that qualify for an ESA letter when they limit daily life, how a licensed professional assesses them, and what to expect."
  },
  "/blog/esa-letter-apartments-complete-renters-guide-2026": {
    "title": "ESA Letter for Apartments: Renter's Guide | PawTenant",
    "description": "An ESA letter for apartments in 2026: how to request an accommodation, what landlords can ask, and what renters can do if they're denied."
  },
  "/blog/esa-annual-renewal-subscription-stay-compliant-2026": {
    "title": "ESA Renewal Plans 2026: Stay Compliant | PawTenant",
    "description": "Many landlords expect a letter within 12 months. How an annual ESA renewal plan helps you avoid documentation gaps and keep costs predictable."
  },
  "/blog/florida-esa-laws-what-landlords-can-ask-for": {
    "title": "Florida ESA Laws: What Landlords Can Ask For | PawTenant",
    "description": "Florida ESA laws explained: exactly what Florida landlords can and cannot ask emotional support animal owners for under state and federal law."
  },
  "/blog/new-york-esa-laws-housing-protections": {
    "title": "New York ESA Laws: Housing Protections | PawTenant",
    "description": "If you live in New York and rely on an emotional support animal, you already know how important housing protections are. Learn your rights under NY ESA law."
  },
  "/blog/esa-colorado-denver-2026-guide": {
    "title": "Colorado ESA Housing Rights 2026 | PawTenant",
    "description": "Colorado ESA rights in 2026: CADA protections, Denver rental market trends, and how to get a legitimate Colorado ESA letter for housing."
  },
  "/blog/multiple-esas-one-apartment-2026": {
    "title": "Multiple ESAs in One Apartment: The Law | PawTenant",
    "description": "Can you have multiple ESAs in one apartment? What the Fair Housing Act says, how to request more than one animal, and what landlords can ask."
  },
  "/blog/esa-friendly-hotels-travel-guide-2026": {
    "title": "ESA-Friendly Hotels 2026: Travel Guide & Rights | PawTenant",
    "description": "Finding ESA-friendly hotels in 2026: which chains are most accommodating, your legal rights, and how to avoid surprises when you book."
  },
  "/blog/esa-road-trip-guide-2026": {
    "title": "ESA Road Trip Guide 2026 | PawTenant",
    "description": "Plan an ESA road trip: pet-friendly stops, documentation for hotels and parks, car safety, and keeping your animal comfortable on long drives."
  },
  "/blog/pet-therapy-vs-esa-difference-2026": {
    "title": "Pet Therapy vs ESA vs Service Animal | PawTenant",
    "description": "Pet therapy vs ESA vs psychiatric service dog: licensed professionals compare each option so you can see which fits your mental health needs."
  },
  "/blog/psd-california-2026-guide": {
    "title": "Psychiatric Service Dog in California 2026 | PawTenant",
    "description": "Your psychiatric service dog in California: 2026 ADA access rights, AB 468 rules for PSD letters, airline documentation, and PSD vs ESA."
  },
  "/blog/psd-texas-2026-guide": {
    "title": "Psychiatric Service Dog in Texas 2026 | PawTenant",
    "description": "Your psychiatric service dog in Texas: 2026 ADA rights, housing and airline requirements, and how to get a Texas-compliant PSD letter."
  },
  "/blog/psd-florida-2026-guide": {
    "title": "Psychiatric Service Dog in Florida 2026 | PawTenant",
    "description": "Your psychiatric service dog in Florida: ADA public access, FHA housing protection, Florida's anti-fraud rules, and getting a compliant PSD letter."
  },
  "/blog/psd-new-york-2026-guide": {
    "title": "Psychiatric Service Dog in New York 2026 | PawTenant",
    "description": "Your psychiatric service dog in New York: NYC Human Rights Law, FHA and NYSHRL housing rights, airline documentation, and getting a PSD letter."
  },
  "/blog/how-esa-letter-verification-works-pawtenant": {
    "title": "How ESA Letter Verification Works | PawTenant",
    "description": "How PawTenant's portal verification ID helps customers and landlords confirm a letter without putting a verification identifier on the clinical document."
  },
  "/blog/why-pawtenant-best-verifiable-esa-letter-service": {
    "title": "Why Choose PawTenant for a Verifiable ESA Letter",
    "description": "Why a verifiable ESA letter matters: how PawTenant's built-in landlord verification helps you present credible, licensed documentation."
  },
  "/blog/landlord-verification-esa-letter-guide-2026": {
    "title": "Landlord Verification of ESA Letters | PawTenant",
    "description": "Landlord verification of ESA letters in 2026: what landlords can check, how PawTenant's verification works, and how to present your letter."
  },
  "/blog/esa-letter-verification-protects-housing-rights-2026": {
    "title": "ESA Letter Verification & Housing Rights | PawTenant",
    "description": "Why ESA letter verification matters for your housing rights in 2026, and how PawTenant's system lets landlords confirm a letter quickly."
  },
  "/blog/how-to-request-esa-accommodation-university-2026": {
    "title": "ESA Accommodation From University: How to Ask",
    "description": "Step-by-step guide on requesting emotional support animal accommodation from your university in 2026. Know your rights under the Fair Housing Act."
  },
  "/blog/can-you-have-esa-in-college-dorms": {
    "title": "Can You Have an ESA in College Dorms? | PawTenant",
    "description": "Yes, you can request an ESA in college dorms. How the accommodation process works, the documentation you need, and which schools are ESA-friendly."
  },
  "/blog/esa-letter-college-students-dorm-rights-federal-laws": {
    "title": "ESA Letter for College Students: Dorm Rights | PawTenant",
    "description": "An ESA letter for college students: your dorm rights under the Fair Housing Act and Section 504, and how the university approval process works."
  },
  "/blog/renters-insurance-pet-owners-complete-guide": {
    "title": "Renters Insurance for ESA Owners: 2026 Guide | PawTenant",
    "description": "Everything ESA owners need to know about renters insurance in 2026. What's covered, what's not, and how to protect yourself and your emotional support animal."
  },
  "/blog/flying-with-esa-travel-letter-guide": {
    "title": "Flying With an ESA in 2026: Airline Guide | PawTenant",
    "description": "Flying with an ESA in 2026: which airlines still allow ESAs, what documentation you need, and your best options for traveling with your animal."
  },
  "/blog/exotic-esa-rules-whats-realistically-allowed": {
    "title": "Exotic ESA Rules: What’s Realistically Allowed? | PawTenant",
    "description": "Can a reptile, bird, or other exotic ESA be approved? What's realistically allowed in housing, and what landlords and providers consider."
  },
  "/blog/how-to-get-certification-for-emotional-support-dog": {
    "title": "Emotional Support Dog Certification Guide | PawTenant",
    "description": "Emotional support dog certification isn't official. What matters is an ESA letter from a licensed professional. Here's how the process works."
  },
  "/blog/esa-travel-readiness-consultation-guide-2026": {
    "title": "ESA Travel Readiness Consultation | PawTenant",
    "description": "An ESA travel readiness consultation prepares your documentation, health records, and airline forms before your trip to avoid surprises."
  },
  "/blog/esa-airline-compliance-guide-all-airlines-2026": {
    "title": "ESA Airline Policies 2026: Every Major Airline | PawTenant",
    "description": "ESA airline policies for 2026: Delta, United, American, Southwest, Alaska and JetBlue rules, with the documentation each carrier requires."
  },
  "/what-documents-can-landlord-ask-for-esa": {
    "title": "What Documents Can a Landlord Ask For an ESA?",
    "description": "The documents a landlord can ask for with an ESA: what housing providers can reasonably request, what they can't, and keeping medical details private."
  },
  "/esa-letter-vs-pet-policy": {
    "title": "ESA Letter vs Pet Policy: Does a No-Pet Rule Apply?",
    "description": "ESA letter vs pet policy: does a no-pet rule apply to an emotional support animal, can apartments charge ESA pet rent, and how requests work."
  },
  "/how-to-respond-to-esa-letter-denial": {
    "title": "How to Respond if Your Landlord Denies Your ESA Letter",
    "description": "Facing an ESA letter denial or told it's fake? Calm next steps, what to send your landlord, how verification helps, and the support available."
  },
  "/landlord-says-esa-letter-is-fake": {
    "title": "Landlord Says My ESA Letter Is Fake — What to Do",
    "description": "Landlord says your ESA letter is fake? How to show it's genuine, the warning signs of a truly fake letter, and how to respond with verification."
  },
  "/esa-letter-verification-id": {
    "title": "ESA Letter Verification: What It Is & Why It Helps",
    "description": "What an ESA letter verification ID is, and how a landlord uses it in our portal to confirm a letter is genuine without seeing medical details."
  },
  "/psychiatric-service-dog-letter-online": {
    "title": "Psychiatric Service Dog Letter Online | PawTenant",
    "description": "Get a psychiatric service dog letter online through a licensed provider evaluation. Who qualifies, how it differs from an ESA, and the secure process."
  },
  "/psd-letter-for-apartments": {
    "title": "PSD Letter for Apartments and Housing Requests | PawTenant",
    "description": "How a PSD letter for apartments supports a housing request: what a landlord can ask, Fair Housing rules, and when an ESA letter fits better."
  },
  "/psd-letter-requirements": {
    "title": "PSD Letter Requirements: What You Need to Know | PawTenant",
    "description": "PSD letter requirements: a qualifying psychiatric disability, a task-trained dog, a licensed provider evaluation, and what documentation can do."
  },
  "/can-a-landlord-deny-a-psd-letter": {
    "title": "Can a Landlord Deny a PSD Letter? | PawTenant",
    "description": "Can a landlord deny a PSD letter? What they can verify, the limited valid reasons for denial, and the calm steps to take if it happens to you."
  },
  "/do-you-need-a-psd-letter-for-a-service-dog": {
    "title": "Do You Need a PSD Letter for a Service Dog? | PawTenant",
    "description": "Do you need a PSD letter? Service dogs aren't certified by online registries, but a licensed provider's documentation can help with housing."
  },
  "/blog/esa-arizona-phoenix-tucson-2026-guide": {
    "title": "ESA Arizona 2026: Phoenix & Tucson Renter Rights | PawTenant",
    "description": "Arizona ESA rights in 2026: FHA and Arizona Fair Housing Act protections, what Phoenix and Tucson landlords can ask, and getting an Arizona ESA letter."
  },
  "/blog/esa-georgia-atlanta-2026-guide": {
    "title": "Georgia ESA Housing Rights 2026 | PawTenant",
    "description": "Georgia ESA rights in 2026: FHA and Georgia Fair Housing Act protections, what Atlanta landlords can ask, and how to get a legitimate ESA letter."
  },
  "/blog/esa-maryland-baltimore-2026-guide": {
    "title": "Maryland ESA Housing Rights 2026 | PawTenant",
    "description": "Maryland ESA rights in 2026: MFEPA and FHA protections, what Baltimore and Montgomery County landlords can ask, and getting a Maryland ESA letter."
  },
  "/blog/esa-michigan-detroit-grand-rapids-2026-guide": {
    "title": "Michigan ESA Housing Rights 2026 | PawTenant",
    "description": "Michigan ESA rights in 2026: ELCRA and FHA protections, what Detroit and Grand Rapids landlords can ask, and how to get a Michigan ESA letter."
  },
  "/blog/esa-new-jersey-newark-jersey-city-2026-guide": {
    "title": "New Jersey ESA Housing Rights 2026 | PawTenant",
    "description": "New Jersey ESA rights in 2026: the NJ Law Against Discrimination, what Newark, Jersey City and Hoboken landlords can ask, and getting an NJ ESA letter."
  },
  "/blog/esa-nyc-apartments-coop-rent-stabilized-2026-guide": {
    "title": "ESA Rights in NYC Apartments 2026 | PawTenant",
    "description": "How ESA law applies to NYC apartments in 2026: co-ops, rent-stabilized units, NYCHA public housing, and condos in the most complex rental market."
  },
  "/blog/esa-pennsylvania-philadelphia-pittsburgh-2026-guide": {
    "title": "Pennsylvania ESA Housing Rights 2026 | PawTenant",
    "description": "Pennsylvania ESA rights in 2026: PHRA and PFHA protections, what Philadelphia and Pittsburgh landlords can ask, and getting a Pennsylvania ESA letter."
  },
  "/blog/esa-south-florida-miami-fort-lauderdale-2026-guide": {
    "title": "South Florida ESA Housing Rights 2026 | PawTenant",
    "description": "South Florida ESA rights: how Statute 760.27 applies in Miami-Dade, Broward and Palm Beach, the state's toughest markets for documentation."
  },
  "/blog/esa-virginia-northern-va-richmond-2026-guide": {
    "title": "Virginia ESA Housing Rights 2026 | PawTenant",
    "description": "Virginia ESA housing rights in 2026. Learn VHRA protections, what NoVA and Richmond landlords can ask, and how to get a compliant Virginia ESA letter fast."
  },
  "/blog/state/new-york": {
    "title": "New York ESA Housing Rights Blog 2026 | PawTenant",
    "description": "New York ESA housing rights guides for 2026, covering NYC co-ops, rent-stabilized units, and statewide law, written with input from licensed professionals."
  },
  "/blog/state/florida": {
    "title": "Florida ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Florida ESA housing rights guides for 2026, covering Miami, Fort Lauderdale, and statewide ESA law, written with input from licensed professionals."
  },
  "/blog/state/california": {
    "title": "California ESA Housing Rights Blog 2026 | PawTenant",
    "description": "California ESA housing rights guides for 2026, covering AB 468, Los Angeles, and San Francisco, written with input from licensed professionals."
  },
  "/blog/state/texas": {
    "title": "Texas ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Texas ESA housing rights guides for 2026, covering Houston, Dallas, Austin, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/new-jersey": {
    "title": "New Jersey ESA Housing Rights Blog 2026 | PawTenant",
    "description": "New Jersey ESA housing rights guides for 2026, covering Newark, Jersey City, Hoboken, and the NJ LAD, written with input from licensed professionals."
  },
  "/blog/state/illinois": {
    "title": "Illinois ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Illinois ESA housing rights guides for 2026, covering Chicago apartments, ILHRA, and city ordinances, written with input from licensed professionals."
  },
  "/blog/state/pennsylvania": {
    "title": "Pennsylvania ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Pennsylvania ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/ohio": {
    "title": "Ohio ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Ohio ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/michigan": {
    "title": "Michigan ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Michigan ESA housing rights guides for 2026, covering Detroit, Grand Rapids, and the Elliott-Larsen Act, written with input from licensed professionals."
  },
  "/blog/state/arizona": {
    "title": "Arizona ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Arizona ESA housing rights guides for 2026, covering Phoenix, Tucson, Scottsdale, and state fair housing law, written with input from licensed professionals."
  },
  "/blog/state/virginia": {
    "title": "Virginia ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Virginia ESA housing rights guides for 2026, covering Northern VA, Richmond, and the Virginia Human Rights Act, written with input from licensed professionals."
  },
  "/blog/state/colorado": {
    "title": "Colorado ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Colorado ESA housing rights guides for 2026, covering Denver, Boulder, Colorado Springs, and CADA, written with input from licensed professionals."
  },
  "/blog/state/maryland": {
    "title": "Maryland ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Maryland ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/alabama": {
    "title": "Alabama ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Alabama ESA housing rights guides for 2026, covering Birmingham, Huntsville, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/alaska": {
    "title": "Alaska ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Alaska ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/arkansas": {
    "title": "Arkansas ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Arkansas ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/connecticut": {
    "title": "Connecticut ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Connecticut ESA housing rights guides for 2026, covering Hartford, New Haven, and state fair housing law, written with input from licensed professionals."
  },
  "/blog/state/delaware": {
    "title": "Delaware ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Delaware ESA housing rights guides for 2026, covering Wilmington, Dover, and state fair housing law, written with input from licensed professionals."
  },
  "/blog/state/hawaii": {
    "title": "Hawaii ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Hawaii ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/indiana": {
    "title": "Indiana ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Indiana ESA housing rights guides for 2026, covering Indianapolis, Fort Wayne, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/iowa": {
    "title": "Iowa ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Iowa ESA housing rights guides for 2026, covering Des Moines, Cedar Rapids, and the Iowa Civil Rights Act, written with input from licensed professionals."
  },
  "/blog/state/kansas": {
    "title": "Kansas ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Kansas ESA housing rights guides for 2026, covering Wichita, Overland Park, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/kentucky": {
    "title": "Kentucky ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Kentucky ESA housing rights guides for 2026, covering Louisville, Lexington, and the Kentucky Civil Rights Act, written with input from licensed professionals."
  },
  "/blog/state/louisiana": {
    "title": "Louisiana ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Louisiana ESA housing rights guides for 2026, covering New Orleans, Baton Rouge, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/maine": {
    "title": "Maine ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Maine ESA housing rights guides for 2026, covering Portland, Bangor, and the Maine Human Rights Act, written with input from licensed professionals."
  },
  "/blog/state/massachusetts": {
    "title": "Massachusetts ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Massachusetts ESA housing rights guides for 2026, covering Boston, Worcester, and Chapter 151B, written with input from licensed professionals."
  },
  "/blog/state/minnesota": {
    "title": "Minnesota ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Minnesota ESA housing rights guides for 2026, covering Minneapolis, St. Paul, and the Human Rights Act, written with input from licensed professionals."
  },
  "/blog/state/mississippi": {
    "title": "Mississippi ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Mississippi ESA housing rights guides for 2026, covering Jackson, Gulfport, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/missouri": {
    "title": "Missouri ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Missouri ESA housing rights guides for 2026, covering Kansas City, St. Louis, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/montana": {
    "title": "Montana ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Montana ESA housing rights guides for 2026, covering Billings, Missoula, and the Human Rights Act, written with input from licensed professionals."
  },
  "/blog/state/nebraska": {
    "title": "Nebraska ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Nebraska ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/nevada": {
    "title": "Nevada ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Nevada ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/new-hampshire": {
    "title": "New Hampshire ESA Housing Rights Blog 2026 | PawTenant",
    "description": "New Hampshire ESA housing rights guides for 2026, covering Manchester, Nashua, and state anti-discrimination law, plus what landlords can ask."
  },
  "/blog/state/new-mexico": {
    "title": "New Mexico ESA Housing Rights Blog 2026 | PawTenant",
    "description": "New Mexico ESA housing rights guides for 2026, covering Albuquerque, Santa Fe, and the Human Rights Act, written with input from licensed professionals."
  },
  "/blog/state/north-carolina": {
    "title": "North Carolina ESA Housing Rights Blog 2026 | PawTenant",
    "description": "North Carolina ESA housing rights guides for 2026, covering Charlotte, Raleigh, Durham, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/north-dakota": {
    "title": "North Dakota ESA Housing Rights Blog 2026 | PawTenant",
    "description": "North Dakota ESA housing rights guides for 2026, covering Fargo, Bismarck, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/oklahoma": {
    "title": "Oklahoma ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Oklahoma ESA housing rights guides for 2026, covering Oklahoma City, Tulsa, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/oregon": {
    "title": "Oregon ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Oregon ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/state/rhode-island": {
    "title": "Rhode Island ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Rhode Island ESA housing rights guides for 2026, covering Providence, Warwick, and state fair housing law, written with input from licensed professionals."
  },
  "/blog/state/south-carolina": {
    "title": "South Carolina ESA Housing Rights Blog 2026 | PawTenant",
    "description": "South Carolina ESA housing rights guides for 2026, covering Charleston, Columbia, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/south-dakota": {
    "title": "South Dakota ESA Housing Rights Blog 2026 | PawTenant",
    "description": "South Dakota ESA housing rights guides for 2026, covering Sioux Falls, Rapid City, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/tennessee": {
    "title": "Tennessee ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Tennessee ESA housing rights guides for 2026, covering Nashville, Memphis, Knoxville, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/utah": {
    "title": "Utah ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Utah ESA housing rights guides for 2026, covering Salt Lake City, Provo, and the Utah Fair Housing Act, written with input from licensed professionals."
  },
  "/blog/state/vermont": {
    "title": "Vermont ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Vermont ESA housing rights guides for 2026, covering Burlington, Montpelier, and state fair housing law, written with input from licensed professionals."
  },
  "/blog/state/washington-dc": {
    "title": "Washington DC ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Washington DC ESA housing rights guides for 2026, covering the DC Human Rights Act and local protections, written with input from licensed professionals."
  },
  "/blog/state/west-virginia": {
    "title": "West Virginia ESA Housing Rights Blog 2026 | PawTenant",
    "description": "West Virginia ESA housing rights guides for 2026, covering Charleston, Huntington, and fair housing law, written with input from licensed professionals."
  },
  "/blog/state/wisconsin": {
    "title": "Wisconsin ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Wisconsin ESA housing rights guides for 2026, covering Milwaukee, Madison, and the Open Housing Law, written with input from licensed professionals."
  },
  "/blog/state/wyoming": {
    "title": "Wyoming ESA Housing Rights Blog 2026 | PawTenant",
    "description": "Wyoming ESA housing rights guides for 2026, covering state and local fair housing protections, written with input from licensed professionals."
  },
  "/blog/best-cat-breeds-for-emotional-support": {
    "title": "Best Cat Breeds for Emotional Support | PawTenant",
    "description": "Compare companion cat breeds and adult rescue cats by temperament, grooming and daily care. Find a practical emotional support match without registration myths."
  },
  "/blog/best-dog-breeds-for-emotional-support": {
    "title": "Best Dog Breeds for Emotional Support | PawTenant",
    "description": "The best dog breeds for emotional support, compared by energy and care needs. Choose by temperament, plus why adult rescues often fit well."
  },
  "/blog/esa-dogs-vs-esa-cats": {
    "title": "ESA Dogs vs ESA Cats: Which Is Right? | PawTenant",
    "description": "Compare emotional support dogs and cats by routine, temperament, care, housing documentation, and your individual support needs."
  },
  "/blog/can-kittens-be-emotional-support-animals": {
    "title": "Kitten as an Emotional Support Animal? | PawTenant",
    "description": "Thinking of a kitten as an emotional support animal? Realistic care needs, the professional evaluation, and housing considerations before you adopt."
  },
  "/blog/esa-letter-vs-esa-registration": {
    "title": "ESA Letter vs ESA Registration | PawTenant",
    "description": "Understand the difference between an ESA letter and commercial ESA registration, what to ask before paying, and how to prepare an informed housing request."
  },
  "/blog/cheap-esa-letters-red-flags": {
    "title": "Cheap ESA Letters: Red Flags to Avoid | PawTenant",
    "description": "Comparing cheap ESA letters? Check the evaluation, credentials, total cost, privacy and refund terms before you pay for any service."
  },
  "/blog/same-day-esa-letters-legitimate": {
    "title": "Same-Day ESA Letters: Are They Legit? | PawTenant",
    "description": "Are same-day ESA letters legit? A fast service still needs a proper evaluation. What the claims mean, questions to ask, and state rules."
  },
  "/blog/therapist-vs-psychiatrist-esa-letters": {
    "title": "Therapist vs Psychiatrist for an ESA Letter | PawTenant",
    "description": "Therapist vs psychiatrist for an ESA evaluation: compare credentials, existing care, documentation, and what to realistically expect from each."
  },
  "/blog/can-hoas-restrict-emotional-support-animals": {
    "title": "Can HOAs Restrict Emotional Support Animals? | PawTenant",
    "description": "Can HOAs restrict emotional support animals? Accommodation requests, documentation, shared-space rules, and next steps if your HOA says no."
  },
  "/": {
    "title": "Emotional Support Animal Letter Online | PawTenant",
    "description": "Get an emotional support animal letter through a licensed provider evaluation: a verifiable, housing-focused letter and a refund if you don't qualify."
  }
};
